<template>
  <el-table-column
    prop="name"
    sortable="custom"
    label="Név"
    show-overflow-tooltip
    min-width="160"
    fixed
  >
    <template slot-scope="scope">
      <el-link type="primary" @click="$router.replace('/data/storages/view/' + scope.row.id)">
        {{ scope.row.name }}
      </el-link>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
